import { render, staticRenderFns } from "./AddLeaderRuleModal.vue?vue&type=template&id=0a066422&scoped=true"
import script from "./AddLeaderRuleModal.vue?vue&type=script&lang=js"
export * from "./AddLeaderRuleModal.vue?vue&type=script&lang=js"
import style0 from "./AddLeaderRuleModal.vue?vue&type=style&index=0&id=0a066422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a066422",
  null
  
)

export default component.exports